<template>
  <div class="calcFormsForm">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading...
    </div>
    <div v-else-if="salaryItem">
      <v-form ref="salaryArrayForm" v-model="isFormValid" class="salaryItemForm" lazy-validation>
        <div>
          <v-text-field
            v-model="salaryItem.Name"
            label="Name"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="salaryItem.Description"
            label="Description"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <!-- <div>
          <v-select
            v-model="salaryItem.TableName"
            label="Table name"
            :items="availableTables"
            :rules="rules"
            :readonly='!showFormButtons'
            :readonly='!showFormButtons'
            dense
            outlined
          ></v-select>
        </div> -->
        <div>
          <v-select
            v-model="salaryItem.ColumnName"
            label="Column  name"
            :items="availableColumns"
            :readonly="!showFormButtons"
            :rules="rules"
            dense
            outlined
          ></v-select>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="From date"
            v-model="salaryItem.StartDate"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
            append-icon="mdi-arrow-down-bold-box"
            @click:append="openCalculationSelection('StartDate')"
          ></v-text-field>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="To date"
            v-model="salaryItem.EndDate"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
            append-icon="mdi-arrow-down-bold-box"
            @click:append="openCalculationSelection('EndDate')"
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-model="salaryItem.Filter"
            label="Filter"
            :readonly="!showFormButtons"
            :items="availableFilters"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="salaryItem.Valued"
            label="Calculation Type"
            :items="calculationsTypes"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="salaryItem.Selector"
            label="Selector"
            :items="availableSelectors"
            :rules="[selectorRule]"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div v-if="showTermInput">
          <v-text-field
            v-model="salaryItem.Term"
            label="Term"
            type="number"
            min="0"
            :rules="[termRule]"
            :step="1"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div v-if="showBestnInput">
          <v-text-field
            v-model="salaryItem.Bestn"
            label="Best n"
            :readonly="!showFormButtons"
            type="number"
            :rules="[bestnRule]"
            min="0"
            :step="1"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="Adjustment"
            v-model="salaryItem.Adjustment"
            dense
            :readonly="!showFormButtons"
            outlined
            append-icon="mdi-arrow-down-bold-box"
            @click:append="openCalculationSelection('Adjustment')"
          ></v-text-field>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="Anniversary Date"
            v-model="salaryItem.AtAnniversary"
            :readonly="!showFormButtons"
            dense
            outlined
            append-icon="mdi-arrow-down-bold-box"
            @click:append="openCalculationSelection('AtAnniversary')"
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-model="salaryItem.Rounding"
            label="Rounding"
            :items="availableRoundings"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div v-if="salaryItem.Rounding != 'None'">
          <v-text-field
            v-model="salaryItem.RoundAmount"
            label="Rounding Amount"
            type="number"
            min="0"
            :step="0.01"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
      </v-form>
      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <v-btn v-if="itemId" color="error" outlined @click="onDelete" class="mr-4">
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCopy" class="mr-4"> Copy </v-btn>
          <v-btn color="primary" outlined @click="onTest" class="mr-4"> Test </v-btn>
          <v-btn color="primary" outlined @click="onCancel" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert type="info" outlined dense>No info found for this element</v-alert>
    </div>
    <Dialog ref="confirmationDialog" v-model="dialog" />
    <CalculationSelection
      ref="calculationSelection"
      :levelId="planId"
      :typeList="availableCalculationTypes"
      @select="onSelect"
    />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import CalculationSelection from './Popups/CalculationSelection.vue';

export default {
  name: 'SalaryArrayForm',
  components: {
    Dialog,
    CalculationSelection,
  },
  props: {
    itemId: { type: Number },
    planId: { type: Number },
  },

  data() {
    return {
      loading: false,
      isFormValid: false,
      dialog: false,
      salaryItem: null,
      rules: [(value) => !!value || 'Required.'],
      availableTables: ['Salary'],
      availableColumns: [],
      availableFilters: [
        { value: 'All', text: 'All' },
        { value: 'Non Zero', text: 'Non Zero' },
        { value: 'GT0', text: 'Greater Than 0' },
        { value: 'LT0', text: 'Less Than 0' },
        { value: 'GTE0', text: 'GTE 0' },
        { value: 'LTE0', text: 'LTE 0' },
      ],
      calculationsTypes: [
        '',
        'Average',
        'Sum',
        'Earliest',
        'Latest',
        'LatestBefore',
        'Highest',
        'Lowest',
      ],
      availableSelectors: ['', 'All', 'Best consecutive n in x', 'Best n in x', 'Last n'],
      availableRoundings: ['None', 'Nearest', 'Highest', 'Lowest'],
      showSelectItem: true,
      calculationSelectionProperty: null,
      availableCalculationTypes: ['Date', 'Inputs'],
    };
  },

  computed: {
    selectedTableName() {
      return this.salaryItem ? this.salaryItem.TableName : null;
    },
    showTermInput() {
      return this.salaryItem && this.salaryItem.Selector != 'All' && this.salaryItem.Selector != '' && this.salaryItem.Selector!='Last n';
    },
    showBestnInput() {
      return (
        this.salaryItem &&
        this.salaryItem.Selector != 'All' &&
        this.salaryItem.Selector != '' 
        //&&
        //this.salaryItem.Selector != 'Last n'
      );
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    itemId: function () {
      if (this.itemId) this.getSalaryArray(this.itemId);
      else this.createNewSalaryArray();
    },
    selectedTableName: function () {
      if (this.selectedTableName) this.getGridHeaders();
      else this.availableColumns = [];
    },
    showSelectorInput: function () {
      if (this.salaryItem && !this.showSelectorInput) this.salaryItem.Selector = null;
    },
    showTermInput: function () {
      if (this.salaryItem && !this.showTermInput) this.salaryItem.Term = 0;
    },
    showBestnInput: function () {
      if (this.salaryItem && !this.showBestnInput) this.salaryItem.Bestn = 0;
    },
  },

  created: function () {
    if (this.itemId) this.getSalaryArray(this.itemId);
    else this.createNewSalaryArray();
  },

  methods: {
      onCopy() {
      const isFormValid = this.$refs.salaryArrayForm.validate();
      if (isFormValid) this.copyData();
    },
     async copyData() {
      try {
        let response = await this.$api.post(
          '/CalculationItem/CopySalaryItem',
          this.salaryItem
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Item was copied',
        });
        this.$emit('reloadList', 'update', response.data.Value);
      } catch (err) {
        console.error(err);
      }
    },
    createNewSalaryArray() {
      this.salaryItem = {
        ArrayId: 0,
        CalcId: 0,
        StartDate: '',
        EndDate: '',
        Selector: '',
        Filter: 'All',
        TableName: 'Salary',
        ColumnName: '',
        Valued: 'Average',
        Term: 0,
        Bestn: 0,
        Manager: 0,
        Fund: 0,
        ContributionType: '',
        TransactionType: '',
        ProfileType: '',
        Adjustment: '',
        AtAnniversary: '',
        PlanId: this.planId,
        GroupId: 0,
        Name: '',
        Description: '',
        CalcType: 'Salary Array',
        Expression: null,
        Rounding: 'None',
        RoundAmount: 0,
        RoundPeriod: null,
        Tag: null,
        Level: '',
        Username: null,
        DateChanged: '',
      };
    },
    termRule(value) {
      if (this.showTermInput) return !!value || 'Required.';

      return true;
    },

    bestnRule(value) {
      if (this.showBestnInput) return !!value || 'Required.';

      return true;
    },

    selectorRule(value) {
      if (
        this.salaryItem &&
        (this.salaryItem.Valued == 'Average' || this.salaryItem.Valued == 'Sum')
      )
        return !!value || 'Required.';

      return true;
    },

    onCancel() {
      if (this.itemId) this.getSalaryArray(this.itemId);
      else this.createNewSalaryArray();
    },

    onSave() {
      const isFormValid = this.$refs.salaryArrayForm.validate();
      if (isFormValid) this.saveData();
    },

    onTest() {
      this.$emit('setTestMode');
    },

    openCalculationSelection(property) {
      if (!this.showFormButtons) return;
      this.calculationSelectionProperty = property;
      this.availableCalculationTypes = property == 'Adjustment' ? ['Other'] : ['Date', 'Inputs'];
      const selectDialog = this.$refs.calculationSelection;
      selectDialog.open();
    },

    onSelect(val) {
      this.salaryItem[this.calculationSelectionProperty] = val;
      this.calculationSelectionProperty = null;
    },

    async getGridHeaders() {
      if (this.selectedTableName) {
        try {
          const response = await this.$api.get(
            '/datadictionary/GetFieldList?planId=' +
              this.planId +
              '&formName=' +
              this.selectedTableName
          );

          if (response.data.length) this.processColumns(response.data);
        } catch (err) {
          console.log(err.message);
        }
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteSalaryArray();
      } catch (err) {
        console.log();
      }
    },

    async getSalaryArray() {
      this.loading = true;
      this.salaryItem = null;
      try {
        let response = await this.$api.get('/SalaryArray/GetSalaryItem?id=' + this.itemId);
        var data = response.data;
        this.salaryItem = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async saveData() {
      this.updateSalaryArray();
    },

    async updateSalaryArray() {
      try {
        let response = await this.$api.post('/SalaryArray/UpdateSalaryItem', this.salaryItem);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Salary was saved',
        });
        if (this.salaryItem.CalcId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
        }
        this.getSalaryArray();
      } catch (err) {
        console.error(err);
      }
    },

    async deleteSalaryArray() {
      try {
        await this.$api.delete('/SalaryArray/DeleteSalaryItem?id=' + this.itemId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Element is deleted',
        });
        this.$emit('reloadList', 'delete');
      } catch (err) {
        console.error(err);
      }
    },

    processColumns(gridHeaders) {
      const result = [];
      if (gridHeaders && gridHeaders.length > 0) {
        gridHeaders.forEach((x) => {
          result.push({ value: x.ShortName, text: x.Description });
        });
      }
      this.availableColumns = result;
    },
  },
};
</script>

<style lang="scss" scoped>
.calcFormsForm {
  .salaryItemForm {
    .externalSelectionInput {
      display: flex;

      .selectIcon {
        margin-top: -25px;
      }
    }
  }
}
</style>
